// extracted by mini-css-extract-plugin
module.exports = {"Main":"OffSiteStockingItem_Main__DeJX1"};